let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

// ABWEICHUNG VON DAWN (26.09.2026): jeder Abonnent laeuft fuer sich. Dawn rief
// alle synchron ohne Schutz auf — warf einer (z. B. price-per-item.js bei einem
// Korb ohne `items`), brach publish() mitten in der Liste ab, und der Aufrufer
// kam nie bei renderContents an: der Artikel lag im Korb, die Schublade blieb
// zu. Ein Fehler landet jetzt in der Konsole, die anderen Abonnenten und der
// Aufrufer laufen weiter.
function publish(eventName, data) {
  if (subscribers[eventName]) {
    const promises = subscribers[eventName].map((callback) => {
      try {
        return callback(data);
      } catch (e) {
        console.error(e);
        return undefined;
      }
    });
    return Promise.all(promises);
  } else {
    return Promise.resolve();
  }
}
